/**
 * This file imports all default reducers from slices and exports them as an object
 */

import authSlice, { AuthState } from './auth';
import fullProfileSlice, { ProfileState } from './fullProfile';
import orgsSlice, { OrgsMgtState } from './organizations';
import globalSlice, { GlobalState } from './global';
import { ReducersMapObject } from '@reduxjs/toolkit';
import languageSlice, { LanguageState } from './locales';
import memberSlice, { MemberState } from './member';
import staffSlice, { StaffState } from './staff';
import navigationSlice, { NavigationState } from './navigation';
import certificateSlice, { CertificateState } from './certificate';

export interface StoreType {
  auth: AuthState;
  orgs: OrgsMgtState;
  global: GlobalState;
  full: ProfileState;
  language: LanguageState;
  member: MemberState;
  staff: StaffState;
  certificate: CertificateState;
  navigation: NavigationState;
}

const allReducers: ReducersMapObject<StoreType> = {
  auth: authSlice,
  orgs: orgsSlice,
  global: globalSlice,
  full: fullProfileSlice,
  language: languageSlice,
  member: memberSlice,
  staff: staffSlice,
  certificate: certificateSlice,
  navigation: navigationSlice,
};

export default allReducers;